import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useAuth } from "@/context/AuthContext";
import AuthForm from "./AuthForm";

export default function AuthDialog() {
  const { authDialogOpen, authDialogMode, setAuthDialogMode, closeAuth } = useAuth();

  return (
    <Dialog open={authDialogOpen} onOpenChange={(o) => (o ? null : closeAuth())}>
      <DialogContent
        data-testid="auth-dialog"
        className="sm:max-w-md p-8 rounded-3xl border border-[#8A97A8]/25 bg-white"
      >
        <AuthForm
          mode={authDialogMode}
          onModeChange={setAuthDialogMode}
          onSuccess={closeAuth}
          compact
        />
      </DialogContent>
    </Dialog>
  );
}
